import { render, staticRenderFns } from "./FiltroPesquisaTramitados.vue?vue&type=template&id=afe89db2&scoped=true"
import script from "./FiltroPesquisaTramitados.vue?vue&type=script&lang=js"
export * from "./FiltroPesquisaTramitados.vue?vue&type=script&lang=js"
import style0 from "./FiltroPesquisaTramitados.vue?vue&type=style&index=0&id=afe89db2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe89db2",
  null
  
)

export default component.exports